import { render, staticRenderFns } from "./_fixedVaultTable.vue?vue&type=template&id=55f270bc"
import script from "./_fixedVaultTable.vue?vue&type=script&lang=js"
export * from "./_fixedVaultTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports